import { apiRequest } from './apiClient';

/**
 * SMS listesini getir
 * @param {Object} params - Query parametreleri
 * @param {number} params.sayfa - Sayfa numarası (default: 1)
 * @param {number} params.limit - Sayfa başına kayıt sayısı (default: 50)
 * @returns {Promise<Object>} - SMS listesi ve sayfalama bilgisi
 */
export const getSms = async (params = {}) => {
  const { sayfa = 1, limit = 50 } = params;
  
  const queryParams = {};
  if (sayfa) queryParams.sayfa = sayfa;
  if (limit) queryParams.limit = limit;
  
  return await apiRequest('/api/admin/sms', {
    method: 'GET',
    params: queryParams,
  });
};

/**
 * Müşteriye ait SMS kayıtları (telefon eşleşmesi)
 * @param {string} customerId - Müşteri ID
 * @param {Object} params - sayfa, limit (varsayılan limit 25)
 */
export const getCustomerSms = async (customerId, params = {}) => {
  const { sayfa = 1, limit = 25 } = params;

  const queryParams = {};
  if (sayfa) queryParams.sayfa = sayfa;
  if (limit) queryParams.limit = limit;

  return await apiRequest(`/api/customers/${customerId}/sms`, {
    method: 'GET',
    params: queryParams,
  });
};

/**
 * Tek SMS teslim durumunu NetGSM'den yenile
 * @param {string} smsId
 */
export const refreshSmsDelivery = async (smsId) => {
  return await apiRequest(`/api/admin/sms/${smsId}/teslim-yenile`, {
    method: 'POST',
  });
};
